var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.fatalError)?_c('div',{ref:"fatalError",staticClass:"fatal-error"},[_vm._v(_vm._s(_vm.$t('fatalError.prefix') + _vm.fatalError))]):_vm._e(),_c('loading',{attrs:{"active":_vm.loading,"color":"#008093"}}),_c('vue-snotify'),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }